import { CSSProperties } from 'react';

import { getThemeColor as getThemeColorDS } from '@cast/design-system';

/** @deprecated use `getThemeColor` from `@cast/design-system` */
export const getThemeColor = getThemeColorDS;

export const shadowDividerProps = (
  orientation: 'horizontal' | 'vertical'
): CSSProperties => ({
  position: 'absolute',
  background: `linear-gradient(${
    orientation === 'vertical' ? '90deg' : '180deg'
  }, #C4C4C4 -17.86%, rgba(196, 196, 196, 0) 76.19%)`,
  opacity: 0.18,
  ...(orientation === 'vertical'
    ? { width: 18, height: '100%' }
    : { width: '100%', height: 18 }),
});
